<template>
  <div class="column is-12">
    <div class="columns">
      <div class="column">
        <span class="label edit-box__includes-inline-input">
          {{ $t('attributes.title') }}

          <a
            class="edit-button"
            @click="toggleAttributesModal"
          >
            <i
              aria-hidden="true"
              class="fa fa-pencil-square-o fa-lg"
            />
          </a>
        </span>
      </div>

      <Attributes
        v-if="showAttributesModal"
        :all-attributes="allAttributes"
        :active-attributes="activeAttributes"
        @toggle-modal="toggleAttributesModal"
        @save="saveAttributes"
      />
    </div>

    <div
      v-if="activeAttributes.length > 0"
      class="columns"
    >
      <div class="column">
        <ul class="attribute-list">
          <li
            :key="attribute.id"
            v-for="attribute in activeAttributes"
            class="attribute-item"
          >
            <i
              class="fa fa-check-circle is-valid"
              aria-hidden="true"
            />
            {{ attribute.name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
  </template>

<script>
    import Attributes from '../../attributes';
    import { Api } from '../../../../api';
    import { EventBus } from '../../../../utils';

    export default {
        name: 'AttributesTab',
        components: { Attributes },
        data() {
            return {
                showAttributesModal: false,
                allAttributes: [],
                attributeCategories: [],
            };
        },
        async created() {
            this.attributeCategories = (await Api.attributes.getActiveCampsites()).data;
            this.allAttributes = (await Api.attributes.getAllCampsites()).data;
        },
        computed: {
            activeAttributes() {
                if(this.attributeCategories && this.attributeCategories.length >= 0) {
                    return this.attributeCategories.map((c) => c.attributes).flat();
                }
                return [];
            },
        },
        methods: {
            toggleAttributesModal() {
                this.showAttributesModal = !this.showAttributesModal;
            },
            async saveAttributes(attributes) {
                const updatedAttributes = (await Api.attributes.setCampsites(attributes)).data;
                this.toggleAttributesModal();
                this.attributeCategories = updatedAttributes;
                EventBus.$emit(EventBus.SHOW_NOTIFICATION, {
                    title: `<h3>${this.$t('generic.saveSuccessHeadline')}</h3>`,
                    direction: 'Up',
                    body: this.$t('generic.saveSuccess'),
                });
            },
        },
    };
    </script>

<style scoped lang="scss">
.attribute-list {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.attribute-item {
  display: flex;
  align-items: center;
  gap: 0.15rem;
  flex-basis: 32%;
}
</style>



// WEBPACK FOOTER //
// src/views/components/campground-settings/tabs/AttributesTab.vue